import theme from '../../base';

const tabNav = {
  traceColor: theme.colors.neutrals.gray700,
  foreground: theme.colors.neutrals.gray200,
  foregroundActive: theme.colors.neutrals.white,
  activeColor: theme.colors.blues.blue500,
  focusActiveColor: theme.colors.blues.blue500,
  hoverColor: theme.colors.blues.blue200,
};

export default tabNav;
